import { render, staticRenderFns } from "./lesAtouts.vue?vue&type=template&id=35f33935"
import script from "./lesAtouts.vue?vue&type=script&lang=js"
export * from "./lesAtouts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderLesAtouts: require('/home/etienne/AM-frontend/components/HeaderLesAtouts.vue').default})
